<template>
  <uni-popup ref="popupRef" class="c-popup-center" type="center" :mask-click="false">
    <slot />

    <view v-if="hasClose" class="c-popup-center__close">
      <c-img class="c-popup-center__close-img" remote-name="popup_close" @click="handleClose" />
    </view>
  </uni-popup>
</template>

<script setup lang="ts">
import { CANCEL_EVENT } from '@/constants';
import { ref, toRefs } from 'vue';

interface Props {
  hasClose?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  hasClose: true,
});
const { hasClose } = toRefs(props);

const popupRef = ref(null);

const emits = defineEmits([CANCEL_EVENT]);

const handleClose = () => {
  close();
  emits(CANCEL_EVENT);
};

const open = () => popupRef.value?.open();

const close = () => popupRef.value?.close();

defineExpose({
  open,
  close,
});
</script>

<style scoped lang="scss">
.c-popup-center {
  position: relative;
  z-index: 9991;

  .c-popup-center__close {
    display: flex;
    justify-content: center;
    margin-top: 60rpx;

    .c-popup-center__close-img {
      display: block;
      width: 60rpx;
      height: 60rpx;
    }
  }
}
</style>
